import { useMutation, useQueryClient } from "@tanstack/react-query"
import { apiFetch } from "../../../framework/api"
import { useAuthToken } from "../../../hooks/useAuthToken"
import type { PreparedPushNotificationItem, UpdatePreparedPushNotificationRequest } from "../types"

type UpdatePreparedPushParams = {
  uid: string
  data: UpdatePreparedPushNotificationRequest
}

export function useUpdatePreparedPush() {
  const token = useAuthToken()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ uid, data }: UpdatePreparedPushParams) => {
      return await apiFetch<PreparedPushNotificationItem>(`/admin/prepared-pushes/${uid}`, {
        token,
        method: "PATCH",
        body: JSON.stringify(data),
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["preparedPushes"] })
    },
  })
}

